import { Diagnostic, Rule } from "@siteimprove/alfa-act";
import { Err, Ok } from "@siteimprove/alfa-result";
import { Trilean } from "@siteimprove/alfa-trilean";
import { Criterion, Technique } from "@siteimprove/alfa-wcag";
import { expectation } from "../common/act/expectation.js";
import { isPassed } from "../common/act/is-passed.js";
import R26 from "../sia-r26/rule.js";
import R32 from "../sia-r32/rule.js";
import R33 from "../sia-r33/rule.js";
import { Scope, Stability } from "../tags/index.js";
export default Rule.Composite.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r35",
    requirements: [
        Criterion.of("1.2.1"),
        Technique.of("G159"),
        Technique.of("G166"),
    ],
    tags: [Scope.Component, Stability.Stable],
    composes: [R26, R32, R33],
    evaluate() {
        return {
            expectations(outcomes) {
                return {
                    1: expectation(Trilean.some(outcomes, isPassed), () => Outcomes.HasAlternative, () => Outcomes.HasNoAlternative),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasAlternative = Ok.of(Diagnostic.of(`The \`<video>\` element has an alternative`));
    Outcomes.HasNoAlternative = Err.of(Diagnostic.of(`The \`<video>\` element does not have an alternative`));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=rule.js.map